export const ru = {
    manager: 'Менеджер',
    moscow: 'Москва',
    regions: 'Регионы',
    'support-phone': 'Телефоны поддержки'
};
